var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-plugin"},[_c('a',{attrs:{"id":"copy-btn","data-clipboard-text":_vm.clipboardText},on:{"click":_vm.copy}},[_vm._v("复制")])])
}
var staticRenderFns = []

export { render, staticRenderFns }